/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEventStateRequestDto
 */
export interface CreateEventStateRequestDto {
    /**
     * Unique code for the event state (uppercase letters, digits, and underscores only, starting with a letter)
     * @type {string}
     * @memberof CreateEventStateRequestDto
     */
    code: string;
    /**
     * Name of the event state
     * @type {string}
     * @memberof CreateEventStateRequestDto
     */
    name: string;
}

/**
 * Check if a given object implements the CreateEventStateRequestDto interface.
 */
export function instanceOfCreateEventStateRequestDto(value: object): value is CreateEventStateRequestDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateEventStateRequestDtoFromJSON(json: any): CreateEventStateRequestDto {
    return CreateEventStateRequestDtoFromJSONTyped(json, false);
}

export function CreateEventStateRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEventStateRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
    };
}

export function CreateEventStateRequestDtoToJSON(json: any): CreateEventStateRequestDto {
    return CreateEventStateRequestDtoToJSONTyped(json, false);
}

export function CreateEventStateRequestDtoToJSONTyped(value?: CreateEventStateRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

